var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"feed container",staticStyle:{"background":"#ffffff"}},[_vm._m(0),_c('section',[_c('vue-good-table',{attrs:{"columns":_vm.columns,"rows":_vm.data,"sort-options":{
        enabled: true,
        initialSortBy: { field: 'id', type: 'desc' },
      },"search-options":{
        enabled: true,
      }}})],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hero"},[_c('h4',{staticClass:"title is-4 is-"},[_vm._v("Invites")])])}]

export { render, staticRenderFns }